import * as React from 'react';

export const IconReliable = (props: React.HTMLAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    {/* tslint:disable-next-line:max-line-length */}
    <path
      fill="#2E9E00"
      fillRule="evenodd"
      d="M9.27 2.505A22.146 22.146 0 0 1 6 0a23.087 23.087 0 0 1-2.8 2.2A25.292 25.292 0 0 1 0 4v1h1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5h1V4a24.31 24.31 0 0 1-1.756-.909A43.111 43.111 0 0 0 5.997 10.5C5.18 8.829 3.607 6.68 2.5 5.542l1.06-1.223a16.712 16.712 0 0 1 2.372 3.13c.82-1.572 2.079-3.363 3.338-4.944z"
    ></path>
  </svg>
);
